import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import DefaultLayout from '../../components/organisms/DefaultLayout';
import { RootState } from '../../store';
import Alert from '../../components/atoms/Alert';
import { PASSWORD_RESET } from '../constants/urls';
import { usePostponePasswordChangeMutation } from '../../store/apis/password';
import { ToastContext } from '../../contexts/Toast';
import { CustomErrorType } from '../../store/apis/@types';
import { setUser } from '../../store/auth';

function PrivateRoutesGuard() {
	const dispatch = useDispatch();

	const navigate = useNavigate();
	const sessionId = useSelector((state: RootState) => state.auth.user?.id);
	const isLogin = !!sessionId;
	const user = useSelector((state: RootState) => state.auth.user);
	const [showPasswordAlert, setShowPasswordAlert] = useState(false);

	const setToast = useContext(ToastContext);
	const [postponePassword] = usePostponePasswordChangeMutation();

	// Check if password change is due
	useEffect(() => {
		setShowPasswordAlert(!!user?.quarterlyPasswordChangeDue);
	}, [user]);

	const handlePostponePasswordChange = async () => {
		if (!user?.accountId) return;
		// TODO: 백앤드 완성후, 주석 해제
		const res = await postponePassword({ accountId: String(user.accountId) });

		if ('error' in res) {
			setToast(
				'error',
				(res.error as CustomErrorType).data.translate ||
					(res.error as CustomErrorType).data.message,
			);
		} else {
			setToast('info', '수정이 완료되었습니다.');

			dispatch(
				setUser({
					...user,
					quarterlyPasswordChangeDue: false,
				}),
			);
		}

		setShowPasswordAlert(false);
	};

	const handleConfirmAlertClose = () => {
		navigate(PASSWORD_RESET);
	};

	return isLogin ? (
		<DefaultLayout hasAside>
			{showPasswordAlert && (
				<Alert
					title="보안점검"
					closeButtonText="나중에 변경"
					closeButtonClick={handlePostponePasswordChange}
					onConfirmButtonText="지금변경"
					onConfirmButtonClick={handleConfirmAlertClose}
					isVisible={showPasswordAlert}
					onInteractOutside
				>
					패스워드 변경이 필요합니다.
				</Alert>
			)}
			<Outlet />
		</DefaultLayout>
	) : (
		<Navigate to="/login" replace />
	);
}

export default PrivateRoutesGuard;
